import React, { useEffect, useRef } from 'react';
import ChatMessage from './ChatMessage';
import TypingIndicator from './TypingIndicator';
import QuickReplies from './QuickReplies';

const ChatBody = ({
  loading,
  greetingText,
  messages,
  user,
  typing,
  error,
  showGreetingChips,
  quickActions,
  suggestedQuestions,
  sending,
  onSelectQuick,
  onFeedback,
  onRetry,
  onDismissError
}) => {
  const bottomRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }, [messages, typing, error, loading]);

  const lastBotPayload = [...messages].reverse().find((m) => m.role === 'bot' && !m.is_error)?.payload;
  const followUpChips = lastBotPayload?.quick_replies?.length
    ? lastBotPayload.quick_replies
    : (lastBotPayload?.suggested_questions || []);

  if (loading) {
    return (
      <div className="edugenie-body" ref={containerRef}>
        <div className="edugenie-loading" role="status" aria-live="polite">
          <div className="spinner-border spinner-border-sm text-danger" aria-hidden="true" />
          Loading EduGenie…
        </div>
      </div>
    );
  }

  return (
    <div className="edugenie-body" ref={containerRef} aria-live="polite">
      {greetingText ? (
        <div className="edugenie-greeting" role="status">
          {greetingText}
        </div>
      ) : null}

      {showGreetingChips ? (
        <QuickReplies
          items={quickActions.length ? quickActions : suggestedQuestions}
          onSelect={onSelectQuick}
          disabled={sending || typing}
        />
      ) : null}

      {messages.map((message) => (
        <ChatMessage
          key={message.id}
          message={message}
          user={user}
          onFeedback={onFeedback}
          onRetry={onRetry}
        />
      ))}

      {!showGreetingChips && !typing && followUpChips.length > 0 ? (
        <QuickReplies
          items={followUpChips}
          onSelect={onSelectQuick}
          disabled={sending || typing}
        />
      ) : null}

      {typing ? <TypingIndicator /> : null}

      {error ? (
        <div className="edugenie-error-box" role="alert">
          <span>{error}</span>
          <button
            type="button"
            className="edugenie-retry-btn"
            onClick={onDismissError}
            aria-label="Dismiss error"
          >
            Dismiss
          </button>
        </div>
      ) : null}

      <div ref={bottomRef} />
    </div>
  );
};

export default ChatBody;
